import SpecialNumberTextField from './SpecialNumberTextField';

const PatternField = (props) => (
    <SpecialNumberTextField
        {...props}
        name="pattern"
        label="Pattern"
        placeholder="Enter pattern"
    />
);

export default PatternField;
